// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DeactivateEnrollmentRequest {
    static getAttributeTypeMap() {
        return DeactivateEnrollmentRequest.attributeTypeMap;
    }
}
DeactivateEnrollmentRequest.discriminator = undefined;
DeactivateEnrollmentRequest.additionalProperties = false;
DeactivateEnrollmentRequest.attributeTypeMap = [
    {
        "name": "enrollmentId",
        "baseName": "enrollmentId",
        "type": "number"
    },
    {
        "name": "effectiveDate",
        "baseName": "effectiveDate",
        "type": "Date"
    },
];
//# sourceMappingURL=deactivateEnrollmentRequest.js.map